import { chain, flatten } from 'lodash';
import { endpointClaims } from './endpoint';
import { merge } from '@fluentui/react';
import { ONE_HOUR_IN_MSEC, MICROSOFT_TENANT_ID } from '../../constants';
import { useODataReadInfiniteApi, } from '../odata';
/**
 * Odata API for accessing your own MSRC user account's claims as an unordered list.
 *
 * @see {useMeClaimsStructuredApi}
 */
export const useMeClaimsRawApi = (id, query, options = { enabled: true }) => useODataReadInfiniteApi(`${endpointClaims}${id ? '/' + id : ''}`, query, merge({
    isAuthRequired: true,
    isVerificationRequired: true,
    pageLength: 200,
    useQueryOptions: {
        //There's no reason to re-pull user claims frequently
        cacheTime: ONE_HOUR_IN_MSEC,
        staleTime: ONE_HOUR_IN_MSEC,
    },
}, options));
/** Odata API for accessing your own MSRC user account's claims in a strongly typed format. */
export const useMeClaimsStructuredApi = () => {
    var _a, _b;
    const api = useMeClaimsRawApi();
    const flatData = flatten((_a = api === null || api === void 0 ? void 0 : api.data) === null || _a === void 0 ? void 0 : _a.pages);
    const dataAsDictionary = (_b = chain(flatData)) === null || _b === void 0 ? void 0 : _b.map(({ key, value }) => {
        if (/true|false/gi.test(value)) {
            return [key, Boolean(value)];
        }
        return [key, value];
    }).fromPairs().value();
    return Object.assign(Object.assign({}, api), { data: dataAsDictionary });
};
/**
 * Helper API where data is undefined while loading and true/false based on whether
 * the user is a Microsoft corp user (includes linkedin, github, etc)
 */
export const useIsCorpUserApi = () => {
    const claimApi = useMeClaimsStructuredApi();
    if (claimApi.data.tid === undefined)
        return Object.assign(Object.assign({}, claimApi), { data: undefined });
    return Object.assign(Object.assign({}, claimApi), { data: claimApi.data.tid
            .toLowerCase()
            .indexOf(MICROSOFT_TENANT_ID.toLowerCase()) !== -1 });
};
